"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMouseEvents = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const hooks_1 = require("../hooks");
const providers_1 = require("../providers");
// eslint-disable-next-line max-lines-per-function
function useMouseEvents(identifier, type, parts = [], isExpanded, textRef, originalPosRef) {
    const { labels, selectedLabelID } = (0, hooks_1.useLabels)();
    const toolsService = (0, providers_1.useToolsService)();
    const labelManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const windowSize = (0, ui_1.useScreenSize)();
    const timeoutId = (0, react_1.useRef)(null);
    const [selectedLabel, setSelectedLabel] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        if (selectedLabelID !== identifier) {
            return;
        }
        const currentLabel = labels === null || labels === void 0 ? void 0 : labels.find(label => label.identifier === selectedLabelID);
        setSelectedLabel(currentLabel);
    }, [identifier, labels, selectedLabel, selectedLabelID]);
    (0, react_1.useEffect)(() => {
        if (!selectedLabel) {
            return;
        }
        let startX = 0;
        let startY = 0;
        let initialX = 0;
        let initialY = 0;
        let isMoved = false;
        const card = document.getElementById(selectedLabel.identifier);
        card === null || card === void 0 ? void 0 : card.addEventListener('mousedown', mouseDown);
        card === null || card === void 0 ? void 0 : card.addEventListener('touchstart', touchStart);
        function mouseDown(e) {
            if (!card) {
                return;
            }
            startX = e.clientX;
            startY = e.clientY;
            initialX = card.offsetLeft;
            initialY = card.offsetTop;
            isMoved = false;
            document.addEventListener('mousemove', mouseMove);
            document.addEventListener('mouseup', mouseUp);
        }
        function touchStart(e) {
            const isTextClicked = (textRef === null || textRef === void 0 ? void 0 : textRef.current) &&
                textRef.current.contains(e.touches[0].target);
            const isExpandButtonClicked = e.touches[0].target.getAttribute('role') ===
                'button' &&
                e.touches[0].target.getAttribute('aria-label') ===
                    'Expand';
            if (!card) {
                return;
            }
            if (type === bridge_schema_1.LabelType.Group && parts.length > 4 && isExpanded) {
                if (!isTextClicked && !isExpandButtonClicked) {
                    return;
                }
            }
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            initialX = card.offsetLeft;
            initialY = card.offsetTop;
            isMoved = false;
            document.addEventListener('touchmove', touchMove);
            document.addEventListener('touchend', touchEnd);
        }
        function mouseMove(e) {
            if (timeoutId.current) {
                return;
            }
            if (!card ||
                (Math.abs(startX - e.clientX) < 2 && Math.abs(startY - e.clientY) < 2)) {
                return;
            }
            const newX = (initialX + (e.clientX - startX)) / window.innerWidth;
            const newY = (initialY + (e.clientY - startY)) / window.innerHeight;
            // card.style.left = `${newX}px`;
            // card.style.top = `${newY}px`;
            // originalPosRef!.current = { x: newX, y: newY };
            if (originalPosRef) {
                originalPosRef.current = { x: newX, y: newY };
            }
            //fixes too much updateLabelPosition calls
            timeoutId.current = window.setTimeout(() => {
                isMoved = true;
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabelPosition(selectedLabel.identifier, {
                    x: newX,
                    y: newY,
                });
                timeoutId.current = null;
            }, 10);
        }
        function touchMove(e) {
            if (!card || timeoutId.current) {
                return;
            }
            const touch = e.touches[0];
            if (Math.abs(startX - touch.clientX) < 2 &&
                Math.abs(startY - touch.clientY) < 2) {
                return;
            }
            const newX = (initialX + (touch.clientX - startX)) / window.innerWidth;
            const newY = (initialY + (touch.clientY - startY)) / window.innerHeight;
            // card.style.left = `${newX}px`;
            // card.style.top = `${newY}px`;
            // originalPosRef!.current = { x: newX, y: newY };
            if (originalPosRef) {
                originalPosRef.current = { x: newX, y: newY };
            }
            timeoutId.current = window.setTimeout(() => {
                isMoved = true;
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabelPosition(selectedLabel.identifier, {
                    x: newX,
                    y: newY,
                });
                timeoutId.current = null;
            }, 10);
        }
        function mouseUp() {
            cleanup();
        }
        function touchEnd() {
            cleanup();
        }
        function cleanup() {
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
            document.removeEventListener('touchmove', touchMove);
            document.removeEventListener('touchend', touchEnd);
            if (card) {
                // const newX = card.offsetLeft / windowSize.width;
                // const newY = card.offsetTop / windowSize.height;
                // labelManager?.updateLabelPosition(selectedLabel!.identifier, {
                //   x: newX,
                //   y: newY,
                // });
            }
            if (isMoved) {
                isMoved = false;
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateUndoRedoHistory();
            }
        }
        return () => {
            card === null || card === void 0 ? void 0 : card.removeEventListener('mousedown', mouseDown);
            card === null || card === void 0 ? void 0 : card.removeEventListener('touchstart', touchStart);
        };
    }, [
        isExpanded,
        labelManager,
        originalPosRef,
        parts.length,
        selectedLabel,
        textRef,
        type,
        windowSize,
    ]);
}
exports.useMouseEvents = useMouseEvents;
